// A phone's on-screen keyboard makes the visible part of the page shorter. While it is up the page gets
// `keyboard-open`, and the dock steps aside so the box being typed in has the room. (Watching focus
// instead would move the Send button the moment it is tapped.)
export function watchKeyboard() {
  const view = window.visualViewport;
  if (!view) return;
  const update = () =>
    document.documentElement.classList.toggle('keyboard-open', window.innerHeight - view.height * view.scale > 150);
  view.addEventListener('resize', update);
  update();
}
